// extracted by mini-css-extract-plugin
export default {"button":"ij-z","reviewSort":"jj-z"};